// ** UI
import { useTheme } from '@mui/material/styles';

// ** Components
import Section from '@/components/common/Section';
import NewsCarouselVariant from './NewsCarouselVariant';
import MediaCarouselVariant from './MediaCarouselVariant';
import ImageCarouselVariant from './ImageCarouselVariant';

// ** Types
import type { StrapiComponentProps } from '@/types/strapi';
import type { ComponentBlocksCarouselBlock as BlocksCarouselProps } from '@/types/graphql';

type CarouselPropsWithOptionalType = Omit<BlocksCarouselProps, 'carouselType'> & {
	carouselType?: BlocksCarouselProps['carouselType'];
};
type ComponentBlocksCarouselProps = StrapiComponentProps<CarouselPropsWithOptionalType>;
// type ComponentElementCarouselProps = StrapiComponentElementProps<CarouselPropsWithOptionalType>;

const ComponentBlocksCarouselBlock = ({ containerSx, carouselType, ...props }: ComponentBlocksCarouselProps) => {
	const theme = useTheme();

	const renderCarousel = () => {
		switch (carouselType) {
			case 'News':
				return <NewsCarouselVariant {...(props as unknown as React.ComponentProps<typeof NewsCarouselVariant>)} />;
			case 'Image':
				return <ImageCarouselVariant {...(props as unknown as React.ComponentProps<typeof ImageCarouselVariant>)} />;
			default:
				return <MediaCarouselVariant {...(props as unknown as React.ComponentProps<typeof MediaCarouselVariant>)} />;
		}
	};

	return (
		<Section fullWidth backgroundColor={theme.palette.heroLightBackground?.main} containerSx={containerSx}>
			{renderCarousel()}
		</Section>
	);
};

export default ComponentBlocksCarouselBlock;
